<script lang="ts">
  import type { IdentityStatus } from '../../../lib/types';

  export let status: IdentityStatus = 'name_only';
</script>

<span class={`identity-badge identity-${status}`}>
  {#if status === 'linked'}
    Linked
  {:else if status === 'email_only'}
    Email captured
  {:else}
    Name only
  {/if}
</span>

<style>
  .identity-badge {
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.6rem;
    border-radius: var(--radius-md);
    font-size: 0.75rem;
    letter-spacing: 0.04em;
  }

  .identity-linked {
    background: rgba(82, 236, 189, 0.22);
    color: #8defb3;
  }

  .identity-email {
    background: rgba(96, 189, 255, 0.22);
    color: #90caff;
  }

  .identity-name {
    background: rgba(255, 206, 115, 0.24);
    color: #ffce73;
  }
</style>
